import React,{useState,useEffect,useCallback,useRef} from 'react';
import ReactDOM from 'react-dom';
import {useParams} from 'react-router-dom'
import * as actions from '../data/chat_data'
import * as chatNotif from '../data/massage_data'
import * as normalActions from '../store/actions'
import {useSelector,useDispatch} from 'react-redux'
import {EmptyMassage} from '../comps/comps'
import '../styles/chat.css'
import * as authAction from '../store/authAction'
import {getSocket} from '../store/socketClient'
import {createChatRtc} from '../utils/chatRtc'
import { FiVideo,FiPhoneCall,FiPhoneOff,FiMic,FiMicOff,FiCamera,FiPaperclip} from 'react-icons/fi';
import UserAvatar from '../comps/userAvatar'
import { IoIosArrowBack } from "react-icons/io";
import {MdSend} from 'react-icons/md';
import { BsTrash } from 'react-icons/bs';
import FriendPart from '../comps/friendPart'
import {Helmet} from "react-helmet";
import { useNavigate } from "react-router-dom";
import { ChatFileCard, ChatVideoNote, ChatVoiceBubble } from '../comps/chatMediaBubbles'
import ChatGifPane from '../comps/chatGifPane'
import { formatDuration, parseChatMedia, isChatVideoName, isChatImageName, encodeChatFileToken, openChatStream, createChatRecorder, startChatRecorder, uploadChatBlob, uploadChatFile } from '../utils/chatMedia'

const Chat = props => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [error,setError] = useState('');
  const [isload,SetLoad] = useState(true);
const [chat,setChat] = useState('');
const [callState,setCallState] = useState('idle');
const [callKind,setCallKind] = useState('audio');
const [callError,setCallError] = useState('');
const [isMuted,setIsMuted] = useState(false);
const [mediaTick,setMediaTick] = useState(0);
const [callSeconds,setCallSeconds] = useState(0);
const [isOnline,setIsOnline] = useState(false);
const [peerTyping,setPeerTyping] = useState(false);
const [sending,setSending] = useState(false);
const [recordKind,setRecordKind] = useState(null);
const [recordSeconds,setRecordSeconds] = useState(0);
const [videoPreview,setVideoPreview] = useState('');
const [videoReady,setVideoReady] = useState(false);
const [gifOpen,setGifOpen] = useState(false);
const [noteKind,setNoteKind] = useState(() => {
  try { return localStorage.getItem('pinweeloNoteKind') === 'video' ? 'video' : 'voice'; } catch (_) { return 'voice'; }
});
const list= useSelector(state => state.chatReduse.chats);
const Userlist= useSelector(state => {
  const info = state.chatReduse.userinfo;
  if (Array.isArray(info)) return info[0] || {};
  return info || {};
});
const peerName = Userlist.first_name || Userlist.email || 'Chat';
const translations = useSelector(state => state.lang_reduse.lang);
//
const navigate = useNavigate();
 const messagesEndRef = useRef(null);
 const scrollerRef = useRef(null);
 const socketRef = useRef(null);
 const typingTimeoutRef = useRef(null);
 const lastTypingEmitRef = useRef(0);
 const stickToBottomRef = useRef(true);
 const lastCountRef = useRef(0);
 const rtcRef = useRef(null);
 const remoteStreamRef = useRef(null);
 const remoteVideoRef = useRef(null);
 const remoteAudioRef = useRef(null);
 const localVideoRef = useRef(null);
 const callTimeoutRef = useRef(null);
 const callTimerRef = useRef(null);
 const recorderRef = useRef(null);
 const recordStreamRef = useRef(null);
 const recordChunksRef = useRef([]);
 const recordTimerRef = useRef(null);
 const liveVideoRef = useRef(null);
 const videoBlobRef = useRef(null);
 const attachRef = useRef(null);
 const noteHoldRef = useRef(0);
 const noteSwitchedRef = useRef(false);
 // Socket handlers are registered once, so they read the live value from here
 // instead of the stale value captured in their closure.
 const callStateRef = useRef('idle');
 callStateRef.current = callState;

// messagesEndRef.current.addEventListener('scroll', () => {
//      if (messagesEndRef.current.scrollY > 1) {
//        messagesEndRef.current.scrollTo({
//       bottom: 0,
//       behavior: 'smooth',
//   });
//      }
//  });
 //http://127.0.0.1:3000
 //192.168.1.6:3000
useEffect(()=>{
  const userData = localStorage.getItem('userdata');
  if (!userData) return;
  const {pid, id: userid} = JSON.parse(userData);
  try{ dispatch(authAction.auth(userid,pid))}catch(err){
      setError(err.message)
  }
},[dispatch])

const idd = useSelector(state => state.authReduse.id);
useEffect(() => {
  if (!idd || !id) return;
  const getData = async () => {
    SetLoad(true);
    try {
      await dispatch(actions.get_chat(id));
      await dispatch(chatNotif.mark_chat_seen(id, idd));
    }
    catch (err) { setError(err.message); }
    finally { SetLoad(false); }
  };
  getData();
}, [dispatch, idd, id]);

const playChatsound = () =>{new Audio('./click.mp3').play()}

const scrollChatToBottom = () => {
  const el = scrollerRef.current;
  if (!el) return;
  el.scrollTop = el.scrollHeight;
};

const handleChatScroll = () => {
  const el = scrollerRef.current;
  if (!el) return;
  stickToBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
};

useEffect(() => {
  lastCountRef.current = 0;
  stickToBottomRef.current = true;
  setGifOpen(false);
}, [id]);

useEffect(() => {
  if (gifOpen) requestAnimationFrame(scrollChatToBottom);
}, [gifOpen]);

useEffect(() => {
  const el = scrollerRef.current;
  if (!el) return;
  const count = list.length;
  const firstPaint = lastCountRef.current === 0 && count > 0;
  const newMessage = count > lastCountRef.current;
  lastCountRef.current = count;
  if (firstPaint || (newMessage && stickToBottomRef.current)) {
    requestAnimationFrame(scrollChatToBottom);
  }
}, [list.length]);

useEffect(() => {
  if (!idd || !id) return undefined;
  const socket = getSocket();
  socketRef.current = socket;
  const me = String(idd);
  const peer = String(id);

  const belongsToThisChat = (message) => {
    if (!message) return false;
    const from = String(message.from_user);
    const to = String(message.to_user);
    return (from === peer && to === me) || (from === me && to === peer);
  };

  const onMessage = (message) => {
    if (!belongsToThisChat(message)) return;
    if (String(message.from_user) === me) return;
    const text = message.content || message.text;
    if (!text) return;
    dispatch(normalActions.add_to_chat(message.from_user, message.to_user, text, message.id, message.time));
    socket.emit('message delivered', { ids: [message.id], from_user: message.from_user });
    dispatch(chatNotif.mark_chat_seen(peer, me));
    setPeerTyping(false);
    playChatsound();
  };
  const onPresence = (presence) => {
    if (String(presence.userId) === peer) setIsOnline(Boolean(presence.online));
  };
  const onOnlineUsers = (ids) => {
    setIsOnline((ids || []).map(String).includes(peer));
  };
  const onTyping = (payload) => {
    if (String(payload?.userId) !== peer) return;
    setPeerTyping(Boolean(payload.typing));
  };
  const onDelivered = (payload) => {
    if (!payload?.ids) return;
    dispatch(normalActions.mark_chat_delivered(payload.ids));
  };
  const join = () => {
    socket.emit('con', me);
    socket.emit('join-chat', peer);
    fetch(`/api/cn/presence/${encodeURIComponent(peer)}`)
      .then((response) => response.ok ? response.json() : null)
      .then((presence) => {
        if (presence) setIsOnline(Boolean(presence.online));
      })
      .catch(() => {});
  };

  socket.on('send message', onMessage);
  socket.on('presence', onPresence);
  socket.on('online-users', onOnlineUsers);
  socket.on('typing', onTyping);
  socket.on('message delivered', onDelivered);
  socket.on('connect', join);
  if (socket.connected) join();

  const pollIfOffline = async () => {
    if (socket.connected) return;
    try {
      // Presence is in-memory on the server — cheap to poll.
      const response = await fetch(`/api/cn/presence/${id}`);
      if (response.ok) {
        const presence = await response.json();
        setIsOnline(Boolean(presence.online));
      }
    } catch (_) {}
  };
  // Fallback only when the socket is down; 30s keeps us under shared-hosting DB limits.
  const interval = window.setInterval(pollIfOffline, 30000);

  return () => {
    socket.off('send message', onMessage);
    socket.off('presence', onPresence);
    socket.off('online-users', onOnlineUsers);
    socket.off('typing', onTyping);
    socket.off('message delivered', onDelivered);
    socket.off('connect', join);
    socket.emit('typing', { to_user: peer, typing: false });
    socket.emit('leave-chat');
    window.clearInterval(interval);
    window.clearTimeout(typingTimeoutRef.current);
  };
}, [dispatch, idd, id]);

// console.log(list,idd)

useEffect(() => {
  if (!idd || !id || !socketRef.current) return;
  const incoming = list
    .filter(item => String(item.fromm) === String(id))
    .map(item => item.id);
  if (!incoming.length) return;
  socketRef.current.emit('message delivered', { ids: incoming, from_user: id });
}, [idd, id, list]);



 // useLayoutEffect(() => {
 //    console.log('Location changed 2');
 //    
 //  // socket.on('disconnect');
 //  // socket.disconnect();

 //  },[location]);

const sendContent = useCallback(async (message) => {
  const text = String(message || '').trim();
  if (!text || !idd || !id) return;
  setSending(true);
  setError('');
  try {
    const saved = await dispatch(normalActions.add_to_chat_send(idd, id, text));
    if (!saved || !saved.id) throw new Error('Could not send message');
    dispatch(normalActions.add_to_chat(saved.from_user, saved.to_user, saved.content, saved.id, saved.time));
    stickToBottomRef.current = true;
    requestAnimationFrame(scrollChatToBottom);
    const socket = socketRef.current;
    if (socket) {
      socket.emit('con', idd);
      socket.emit('chat message', saved);
      socket.emit('typing', { to_user: id, typing: false });
    }
    setChat('');
    setGifOpen(false);
  } catch (err) {
    setError(err.message || 'Could not send message');
  } finally {
    setSending(false);
  }
}, [dispatch, id, idd])

const chatHandle = useCallback(async () => {
  if (!chat.trim() || sending) return;
  await sendContent(chat);
}, [chat, sendContent, sending])

const stopRecordStream = () => {
  if (recordStreamRef.current) {
    recordStreamRef.current.getTracks().forEach(track => track.stop());
    recordStreamRef.current = null;
  }
  if (liveVideoRef.current) liveVideoRef.current.srcObject = null;
  if (recordTimerRef.current) {
    clearInterval(recordTimerRef.current);
    recordTimerRef.current = null;
  }
}

const cancelRecording = useCallback(() => {
  try { if (recorderRef.current && recorderRef.current.state !== 'inactive') recorderRef.current.stop(); } catch (_) {}
  recorderRef.current = null;
  recordChunksRef.current = [];
  videoBlobRef.current = null;
  stopRecordStream();
  if (videoPreview) URL.revokeObjectURL(videoPreview);
  setVideoPreview('');
  setVideoReady(false);
  setRecordKind(null);
  setRecordSeconds(0);
}, [videoPreview])

const startRecording = useCallback(async (kind) => {
  if (sending || recordKind) return;
  setError('');
  try {
    const stream = await openChatStream(kind);
    recordStreamRef.current = stream;
    recordChunksRef.current = [];
    videoBlobRef.current = null;
    const recorder = createChatRecorder(stream, kind);
    recorderRef.current = recorder;
    recorder.ondataavailable = (event) => {
      if (event.data && event.data.size) recordChunksRef.current.push(event.data);
    };
    recorder.onerror = () => {
      setError('Could not record video on this device');
      cancelRecording();
    };
    startChatRecorder(recorder);
    setGifOpen(false);
    setRecordKind(kind);
    setVideoReady(false);
    setRecordSeconds(0);
    recordTimerRef.current = setInterval(() => {
      setRecordSeconds(seconds => seconds + 1);
    }, 1000);
    if (kind === 'video') {
      requestAnimationFrame(() => {
        if (liveVideoRef.current) {
          liveVideoRef.current.srcObject = stream;
          liveVideoRef.current.play().catch(() => {});
        }
      });
    }
  } catch (err) {
    stopRecordStream();
    setError(err.message || 'Allow microphone or camera to record');
  }
}, [cancelRecording, recordKind, sending])

const onNotePointerDown = useCallback(() => {
  if (sending || recordKind) return;
  noteSwitchedRef.current = false;
  window.clearTimeout(noteHoldRef.current);
  noteHoldRef.current = window.setTimeout(() => {
    noteSwitchedRef.current = true;
    setNoteKind(current => {
      const next = current === 'video' ? 'voice' : 'video';
      try { localStorage.setItem('pinweeloNoteKind', next); } catch (_) {}
      return next;
    });
  }, 400);
}, [recordKind, sending])

const onNotePointerUp = useCallback((event) => {
  event.preventDefault();
  window.clearTimeout(noteHoldRef.current);
  if (noteSwitchedRef.current || sending || recordKind) return;
  startRecording(noteKind);
}, [noteKind, recordKind, sending, startRecording])

const onNotePointerCancel = useCallback(() => {
  window.clearTimeout(noteHoldRef.current);
  noteSwitchedRef.current = true;
}, [])

const finishRecording = useCallback((sendIt) => {
  const recorder = recorderRef.current;
  const kind = recordKind;
  if (!recorder || !kind) return;
  recorder.onstop = async () => {
    const blob = new Blob(recordChunksRef.current, { type: recorder.mimeType || (kind === 'video' ? 'video/webm' : 'audio/webm') });
    stopRecordStream();
    recorderRef.current = null;
    if (!sendIt || blob.size < 400) {
      if (videoPreview) URL.revokeObjectURL(videoPreview);
      videoBlobRef.current = null;
      setVideoPreview('');
      setRecordKind(null);
      setRecordSeconds(0);
      if (sendIt && blob.size < 400) setError('Recording was too short');
      return;
    }
    if (kind === 'video') {
      videoBlobRef.current = blob;
      const url = URL.createObjectURL(blob);
      setVideoPreview(url);
      setVideoReady(true);
      return;
    }
    try {
      const name = await uploadChatBlob(blob, 'voice');
      setRecordKind(null);
      setRecordSeconds(0);
      await sendContent(`voice:${name}`);
    } catch (err) {
      setError(err.message || 'Could not send voice message');
      setRecordKind(null);
      setSending(false);
    }
  };
  try {
    if (recorder.state === 'recording' && typeof recorder.requestData === 'function') recorder.requestData();
  } catch (_) {}
  if (recorder.state !== 'inactive') recorder.stop();
  else recorder.onstop();
}, [recordKind, sendContent, videoPreview])

const sendVideoPreview = useCallback(async () => {
  const blob = videoBlobRef.current;
  if (!blob || sending) return;
  try {
    setSending(true);
    const name = await uploadChatBlob(blob, 'video');
    if (videoPreview) URL.revokeObjectURL(videoPreview);
    videoBlobRef.current = null;
    setVideoPreview('');
    setVideoReady(false);
    setRecordKind(null);
    setRecordSeconds(0);
    await sendContent(`video:${name}`);
  } catch (err) {
    setError(err.message || 'Could not send video');
    setSending(false);
  }
}, [sendContent, sending, videoPreview])

const attachFile = useCallback(async (event) => {
  const file = event.target.files && event.target.files[0];
  event.target.value = '';
  if (!file || sending || !idd || !id) return;
  const isVideo = String(file.type || '').startsWith('video/') || isChatVideoName(file.name);
  const isImage = String(file.type || '').startsWith('image/') || isChatImageName(file.name);
  if (file.size > 80 * 1024 * 1024) {
    setError('File is too large. Choose a smaller file.');
    return;
  }
  setGifOpen(false);
  setError('');
  try {
    setSending(true);
    const name = await uploadChatFile(file);
    const token = isVideo ? `clip:${name}` : isImage ? `photo:${name}` : encodeChatFileToken(name, file.name);
    await sendContent(token);
  } catch (err) {
    setError(err.message || 'Could not send file');
    setSending(false);
  }
}, [id, idd, sendContent, sending])

useEffect(() => {
  if (recordKind === 'video' && !videoReady && liveVideoRef.current && recordStreamRef.current) {
    liveVideoRef.current.srcObject = recordStreamRef.current;
    liveVideoRef.current.play().catch(() => {});
  }
}, [recordKind, videoReady]);

useEffect(() => {
  const max = recordKind === 'video' ? 20 : 60;
  if (!recordKind || recordSeconds < max) return;
  if (recorderRef.current && recorderRef.current.state === 'recording') finishRecording(true);
}, [recordKind, recordSeconds, finishRecording]);

useEffect(() => () => {
  try { if (recorderRef.current && recorderRef.current.state !== 'inactive') recorderRef.current.stop(); } catch (_) {}
  if (recordStreamRef.current) recordStreamRef.current.getTracks().forEach(track => track.stop());
}, [id]);

const HandleChange = e =>{
  setChat(e.target.value);
  const socket = socketRef.current;
  if (!socket || !id) return;
  const now = Date.now();
  if (now - lastTypingEmitRef.current > 400) {
    socket.emit('typing', { to_user: id, typing: true });
    lastTypingEmitRef.current = now;
  }
  window.clearTimeout(typingTimeoutRef.current);
  typingTimeoutRef.current = window.setTimeout(() => {
    socket.emit('typing', { to_user: id, typing: false });
  }, 1400);
}
const cleanupCall = useCallback(() => {
  if (rtcRef.current) {
    rtcRef.current.destroy();
    rtcRef.current = null;
  }
  remoteStreamRef.current = null;
  if (remoteVideoRef.current) remoteVideoRef.current.srcObject = null;
  if (remoteAudioRef.current) remoteAudioRef.current.srcObject = null;
  if (localVideoRef.current) localVideoRef.current.srcObject = null;
  if (callTimeoutRef.current) { clearTimeout(callTimeoutRef.current); callTimeoutRef.current = null; }
  if (callTimerRef.current) { clearInterval(callTimerRef.current); callTimerRef.current = null; }
  setIsMuted(false);
  setCallSeconds(0);
  setCallState('idle');
}, []);

const ensureRtc = useCallback(() => {
  if (rtcRef.current) return rtcRef.current;
  rtcRef.current = createChatRtc({
    getSocket,
    peerId: String(id),
    myId: String(idd || ''),
    onRemoteStream: (stream) => {
      remoteStreamRef.current = stream;
      setMediaTick(tick => tick + 1);
    },
    onMode: (kind) => {
      setCallKind(kind === 'video' ? 'video' : 'audio');
      setMediaTick(tick => tick + 1);
    },
    onError: (message) => setCallError(message)
  });
  return rtcRef.current;
}, [id, idd]);

const startCall = useCallback(async (kind) => {
  if (callStateRef.current !== 'idle') return;
  if (!idd || !id) { setCallError('Please log in to make a call'); return; }
  setCallError('');
  setCallKind(kind);
  setCallState('outgoing');
  try {
    await ensureRtc().startMedia({ video: kind === 'video' });
    setMediaTick(tick => tick + 1);
    socketRef.current?.emit('chat:call', { to: String(id), kind });
    // Auto-cancel after 30 seconds if no answer
    callTimeoutRef.current = setTimeout(() => {
      if (callStateRef.current === 'outgoing') {
        setCallError('No answer');
        socketRef.current?.emit('chat:call-hangup', { to: String(id) });
        cleanupCall();
      }
    }, 30000);
  } catch (err) {
    setCallError('Allow microphone and camera access to start a call');
    cleanupCall();
  }
}, [cleanupCall, ensureRtc, id, idd]);

const startCallTimer = useCallback(() => {
  if (callTimerRef.current) clearInterval(callTimerRef.current);
  setCallSeconds(0);
  callTimerRef.current = setInterval(() => setCallSeconds(s => s + 1), 1000);
}, []);

const acceptCall = useCallback(async () => {
  if (callStateRef.current !== 'incoming') return;
  try {
    await ensureRtc().startMedia({ video: callKind === 'video' });
    setMediaTick(tick => tick + 1);
    setCallState('active');
    startCallTimer();
    socketRef.current?.emit('chat:call-answer', { to: String(id), accept: true });
  } catch (err) {
    setCallError('Allow microphone and camera access to answer');
    socketRef.current?.emit('chat:call-answer', { to: String(id), accept: false });
    cleanupCall();
  }
}, [callKind, cleanupCall, ensureRtc, id, startCallTimer]);

const declineCall = useCallback(() => {
  socketRef.current?.emit('chat:call-answer', { to: String(id), accept: false });
  cleanupCall();
}, [cleanupCall, id]);

const endCall = useCallback(() => {
  socketRef.current?.emit('chat:call-hangup', { to: String(id) });
  cleanupCall();
}, [cleanupCall, id]);

const switchCallKind = useCallback(async (kind) => {
  if (callStateRef.current !== 'active' && callStateRef.current !== 'outgoing') return;
  if (callKind === kind) return;
  try {
    setCallError('');
    if (kind === 'video') await ensureRtc().addVideo();
    else await ensureRtc().dropVideo();
    setCallKind(kind);
    setMediaTick(tick => tick + 1);
  } catch (err) {
    setCallError(kind === 'video' ? 'Allow camera access to switch to video' : 'Could not switch to voice');
  }
}, [callKind, ensureRtc]);

const toggleMute = useCallback(() => {
  setIsMuted(prev => {
    const next = !prev;
    if (rtcRef.current) rtcRef.current.setMuted(next);
    return next;
  });
}, []);

useEffect(() => {
  if (!idd || !id) return undefined;
  const socket = getSocket();
  const peer = String(id);

  const onIncoming = ({ from, kind } = {}) => {
    if (String(from) !== peer) return;
    if (callStateRef.current !== 'idle') return;
    setCallError('');
    setCallKind(kind === 'video' ? 'video' : 'audio');
    setCallState('incoming');
    ensureRtc();
  };
  const onAnswer = ({ from, accept, reason } = {}) => {
    if (String(from) !== peer) return;
    if (!accept) {
      setCallError(reason === 'offline' ? 'They are offline right now' : 'Call declined');
      cleanupCall();
      return;
    }
    if (callStateRef.current === 'active') return;
    if (callStateRef.current !== 'outgoing') return;
    if (callTimeoutRef.current) { clearTimeout(callTimeoutRef.current); callTimeoutRef.current = null; }
    setCallState('active');
    startCallTimer();
    if (rtcRef.current) rtcRef.current.offer().catch(err => setCallError(err.message));
  };
  const onHangup = ({ from } = {}) => {
    if (String(from) !== peer) return;
    cleanupCall();
  };
  const onSignal = (payload) => {
    if (!payload || String(payload.from) !== peer || !rtcRef.current) return;
    rtcRef.current.handleSignal(payload);
  };

  socket.on('chat:call', onIncoming);
  socket.on('chat:call-answer', onAnswer);
  socket.on('chat:call-hangup', onHangup);
  socket.on('chat:signal', onSignal);

  return () => {
    socket.off('chat:call', onIncoming);
    socket.off('chat:call-answer', onAnswer);
    socket.off('chat:call-hangup', onHangup);
    socket.off('chat:signal', onSignal);
  };
}, [cleanupCall, ensureRtc, startCallTimer, id, idd]);

// Media elements only exist while the overlay is open, so bind the streams
// once they have mounted.
useEffect(() => {
  const remote = remoteStreamRef.current || null;
  const local = rtcRef.current ? rtcRef.current.getLocalStream() : null;
  const bind = (el, stream, muted = false) => {
    if (!el) return;
    if (el.srcObject !== stream) el.srcObject = stream;
    el.muted = muted;
    el.volume = muted ? 0 : 1;
    if (stream) el.play().catch(() => {});
  };
  bind(remoteVideoRef.current, callKind === 'video' ? remote : null, true);
  bind(remoteAudioRef.current, remote, false);
  bind(localVideoRef.current, local, true);
}, [callState, callKind, mediaTick]);

useEffect(() => () => {
  if (!rtcRef.current) return;
  if (socketRef.current) socketRef.current.emit('chat:call-hangup', { to: String(id) });
  rtcRef.current.destroy();
  rtcRef.current = null;
}, [id]);

  return(
    <section className="chatHome">

    <Helmet>
  <title>pinweelo Notifications</title>
    <meta name="theme-color" content="#000000" />
{/*<meta name="description" content='here you can check your notifications '/>
<meta name='keywords' content='notifications,messages,enveraworld website,notifications page'/>
 <link rel="canonical" href="https://enveraworld.com/notifications" />*/}
  </Helmet>
  
     <FriendPart  chat='true'/>
  <section className={`Chat${gifOpen ? ' isGifOpen' : ''}`} ref={scrollerRef} onScroll={handleChatScroll}>

        {error &&<EmptyMassage list={list} title={error} />}
    {callError && callState === 'idle' && <div className='callToast' onClick={()=>setCallError('')}>{callError}</div>}
    <EmptyMassage loading={!!isload && !error && (!list || list.length === 0)} list={list} title={translations.thereisnomessages} />
   <div className='headerChat'>
     <button type="button" className="headerChatBack" onClick={() => navigate("/notifications")} aria-label="Go back"><IoIosArrowBack /></button>
     <div className="headerChatUser" role="link" onClick={() => navigate(`/@${id}`)}>
       <div className="headerChatAvatar">
         <UserAvatar alt="" src={Userlist.img} name={peerName} />
         <i className={isOnline ? 'headerChatDot on' : 'headerChatDot'} />
       </div>
       <figure>
         <h1>{peerName}</h1>
         <p className={peerTyping ? 'chatTypingLabel' : ''}>{peerTyping ? 'typing...' : isOnline ? 'online' : 'offline'}</p>
       </figure>
     </div>
     <div className="headerChatActions">
       <button type="button" onClick={()=>startCall('video')} disabled={callState !== 'idle'} aria-label="Video call"><FiVideo /></button>
       <button type="button" onClick={()=>startCall('audio')} disabled={callState !== 'idle'} aria-label="Voice call"><FiPhoneCall /></button>
     </div>
   </div>
    {list.map((item)=>{
      const mine = String(item.fromm) === String(idd);
      const media = parseChatMedia(item.text);
      const isImage = media.kind === 'image';
      const isFileVideo = media.kind === 'fileVideo';
      const isFile = media.kind === 'file';
      return(
<div key={item.id} className={`cont ${mine ? 'contMine' : 'contTheirs'}`}>
  <div className={`bubble ${mine ? 'bubbleMine' : 'bubbleTheirs'}${isImage || isFileVideo || isFile || media.kind === 'video' ? ' bubbleImage' : ''}${media.kind === 'voice' ? ' bubbleVoice' : ''}${media.kind === 'video' ? ' bubbleVideo' : ''}${isFileVideo ? ' bubbleFileVideo' : ''}${isFile ? ' bubbleFile' : ''}`}>
    <div className='messageText'>
      {media.kind === 'image' ? <img alt="shared" src={media.src} /> : null}
      {media.kind === 'voice' ? <ChatVoiceBubble src={media.src} mine={mine} /> : null}
      {media.kind === 'video' ? <ChatVideoNote src={media.src} /> : null}
      {isFileVideo ? <video className="chatFileVideo" src={media.src} controls playsInline preload="metadata" /> : null}
      {isFile ? <ChatFileCard src={media.src} label={media.label} /> : null}
      {media.kind === 'text' ? item.text : null}
    </div>
    <div className='bubbleMeta'>
      <span>{item.date}</span>
      {mine ? <span className={item.status === 'delivered' ? 'deliveryStatus delivered' : 'deliveryStatus'}>{item.status === 'delivered' ? 'Delivered' : 'Sent'}</span> : null}
    </div>
  </div>
  <button className="displayNone" onClick={()=>{dispatch(normalActions.delete_mass(item.id))}}>delete</button>
</div>
)})}
{peerTyping && <div className="cont contTheirs"><div className="bubble bubbleTheirs typingIndicator" aria-label="typing"><span /><span /><span /></div></div>}
<div ref={messagesEndRef} />


{callState !== 'idle' && ReactDOM.createPortal(
<div className='callOverlay' onPointerDown={() => {
  if (remoteAudioRef.current) remoteAudioRef.current.play().catch(() => {})
  if (remoteVideoRef.current) remoteVideoRef.current.play().catch(() => {})
}}>
  <video ref={remoteVideoRef} className={`callRemoteVideo${callKind === 'video' && callState === 'active' ? '' : ' isHidden'}`} autoPlay playsInline />
  <audio ref={remoteAudioRef} autoPlay playsInline />
  <div className='callOverlayGrad' />

  <div className='callTopInfo'>
    <p className='callTopLabel'>{callState === 'incoming' ? `Incoming ${callKind} call` : callState === 'outgoing' ? 'Calling...' : callKind === 'video' ? 'Video Call' : 'Voice Call'}</p>
    {callState === 'active' && <p className='callTimer'>{String(Math.floor(callSeconds / 60)).padStart(2,'0')}:{String(callSeconds % 60).padStart(2,'0')}</p>}
    {callError && <p className='callErrorBadge'>{callError}</p>}
  </div>

  {(callKind !== 'video' || callState !== 'active') && <div className='callCenter'>
    <div className={`callAvatarRing${callState === 'outgoing' || callState === 'incoming' ? ' callAvatarPulse' : ''}`}>
      <UserAvatar alt="" src={Userlist.img} name={peerName} className='callAvatar' />
    </div>
    <h2 className='callPeerName'>{peerName}</h2>
    {callState === 'outgoing' && <p className='callRingingDots'>Ringing<span className='dotPulse'>...</span></p>}
    {callState === 'incoming' && <p className='callRingingDots'>Tap accept to join</p>}
  </div>}

  <div className={`callSelfView${callKind === 'video' ? '' : ' isHidden'}`}>
    <video ref={localVideoRef} autoPlay playsInline muted />
  </div>

  <div className='callControls'>
    {callState === 'incoming' ? <>
      <button type="button" className='callBtn callBtnAccept' onClick={acceptCall} aria-label="Accept call">
        {callKind === 'video' ? <FiVideo /> : <FiPhoneCall />}
      </button>
      <button type="button" className='callBtn callBtnDecline' onClick={declineCall} aria-label="Decline call">
        <FiPhoneOff />
      </button>
    </> : <>
      <button type="button" className={`callBtn callBtnMute${isMuted ? ' callBtnMuted' : ''}`} onClick={toggleMute} aria-label={isMuted ? 'Unmute' : 'Mute'}>
        {isMuted ? <FiMicOff /> : <FiMic />}
      </button>
      <button type="button" className={`callBtn callBtnSwitch${callKind === 'video' ? ' isOn' : ''}`} onClick={()=>switchCallKind('video')} disabled={callKind === 'video'} aria-label="Switch to video">
        <FiVideo />
      </button>
      <button type="button" className={`callBtn callBtnSwitch${callKind === 'audio' ? ' isOn' : ''}`} onClick={()=>switchCallKind('audio')} disabled={callKind === 'audio'} aria-label="Switch to voice">
        <FiPhoneCall />
      </button>
      <button type="button" className='callBtn callBtnEnd' onClick={endCall} aria-label="End call">
        <FiPhoneOff />
      </button>
    </>}
  </div>
</div>,
document.body
)}

{recordKind === 'video' && ReactDOM.createPortal(
<div className="videoNoteOverlay">
  {videoReady ? (
    <video className="videoNotePreview" src={videoPreview} autoPlay loop playsInline muted />
  ) : (
    <video ref={liveVideoRef} className="videoNotePreview" autoPlay playsInline muted />
  )}
  <p className="videoNoteTimer">{formatDuration(recordSeconds)}</p>
  <div className="videoNoteActions">
    <button type="button" className="callBtn callBtnDecline" onClick={cancelRecording} aria-label="Cancel video"><BsTrash /></button>
    {videoReady ? (
      <button type="button" className="callBtn callBtnAccept" onClick={sendVideoPreview} disabled={sending} aria-label="Send video"><MdSend /></button>
    ) : (
      <button type="button" className="videoNoteStop" onClick={() => finishRecording(true)} aria-label="Stop recording" />
    )}
  </div>
</div>,
document.body
)}

  </section>

<div className={`chatDock${gifOpen ? ' isGifOpen' : ''}`}>
<div className={`chatComposer${chat.trim() ? ' isComposing' : ''}${recordKind === 'voice' ? ' isRecording' : ''}${gifOpen ? ' isGifOpen' : ''}`}>
  <div className="chatComposerLiquid" aria-hidden="true">
    <span className="chatComposerBlob chatComposerBlobGif" />
    <div className="chatComposerJoinGroup">
      <span className="chatComposerBlob chatComposerBlobField" />
      <span className="chatComposerBlob chatComposerBlobSend" />
      <span className="chatComposerStick" />
    </div>
  </div>
  <div className="chatComposerUi">
    {recordKind === 'voice' ? (
      <div className="composerRecordBar">
        <button type="button" className="composerRecordCancel" onClick={cancelRecording} aria-label="Cancel recording"><BsTrash /></button>
        <span className="composerRecordDot" />
        <span className="composerRecordTime">{formatDuration(recordSeconds)}</span>
        <button type="button" className="composerSend isReady" onClick={() => finishRecording(true)} disabled={sending || recordSeconds < 1} aria-label="Send voice message"><MdSend /></button>
      </div>
    ) : (
      <>
        <div className="composerTools">
          <button type="button" className="composerClip" onClick={() => attachRef.current && attachRef.current.click()} aria-label="Attach file" disabled={sending}><FiPaperclip /></button>
          <input ref={attachRef} type="file" hidden onChange={attachFile} />
        </div>
        <div className="composerJoinUi">
          <div className="composerField">
            <button type="button" className={`composerGif${gifOpen ? ' isOn' : ''}`} onClick={() => setGifOpen(open => !open)} aria-label="GIFs" aria-pressed={gifOpen} disabled={sending}>GIF</button>
            <input value={chat} onChange={HandleChange} onKeyDown={event => { if (event.key === 'Enter') chatHandle(); }} placeholder='Write a message' disabled={sending} />
          </div>
          {chat.trim() ? (
            <button type="button" className="composerSend" onClick={chatHandle} disabled={sending} aria-label="Send message"><MdSend /></button>
          ) : (
            <button
              type="button"
              className="composerSend"
              disabled={sending}
              aria-label={noteKind === 'video' ? 'Record video. Hold to switch to voice.' : 'Record voice. Hold to switch to video.'}
              onPointerDown={onNotePointerDown}
              onPointerUp={onNotePointerUp}
              onPointerCancel={onNotePointerCancel}
              onContextMenu={event => event.preventDefault()}
            >
              {noteKind === 'video' ? <FiCamera /> : <FiMic />}
            </button>
          )}
        </div>
      </>
    )}
  </div>
</div>
<ChatGifPane open={gifOpen} onPick={(url) => sendContent(url)} />
</div>
  
  </section>
  )
}
export default Chat;
